<template>
    <ContentComp>
        <slot></slot>
        <div class="w-min-400">
            <InputTypeAheadEvent
                placeholder="general.search"
                @item-selected="onItemSelected"
                class="w-min-400"
            />
        </div>

        <div class="my-10 text-center text-gray-500 pt-4">
            <span v-html="$tm('contestant.copyfromeventorselectfromisonen', '', true)"></span>
        </div>

        <template v-if="(Event?.Setup?.ISonenID ?? '') == ''">
            <ISonenSelector
                v-if="externalEventData"
                class="w-min-400"
                :preselect-club="false"
                :hide-label="true"
                v-model="externalEventData"
                v-model:event="selectedExternalEventData"
                @club-selected="
                    () => {
                        selectedEvent = null;
                        value = null;
                    }
                "
            />
        </template>
        <template v-else>
            <ISonenUpdateButton
                class="btn-lg"
                text="contestantimport.updatefromisonen"
            />
        </template>

        <LoadingComp
            v-if="LoadState.isActive"
            :state="LoadState"
            :hideDetails="true"
            :delay="0"
        />

        <ContestantEventDetailsView
            v-else-if="selectedEvent"
            :value="selectedEvent"
        />
        <ContestantEventDetailsView
            v-else-if="selectedExternalEventData"
            :value="selectedExternalEventData.EventInfo"
            :contestantcount="selectedExternalEventData.Contestants.length"
        />
    </ContentComp>
</template>
<script setup lang="ts">
/**
 * Provides a view to search for a event ( defaults to the current event sourceevent if provided ) and copy all the contestants from that event to the current event.
 */
import { ButtonComp, LoadingComp } from '@/components';
import ContentComp from '@/components/layout/ContentComp.vue';
import InputTypeAheadEvent from '@/components/Typeahead/General/InputTypeAheadEvent.vue';
import { useTaskLoader } from '@/composeables';
import { EventDao } from '@/dao';
import type { Eventinfo, ExternalEventDatasourceResponse, TypeAheadItem } from '@/objects/generated';
import { useEventCommonStoreRef } from '@/stores';
import { onMounted, ref, computed, watch } from 'vue';
import ContestantEventDetailsView from './ContestantEventDetailsView.vue';
import ISonenSelector from '../EventInfo/ISonenSelector.vue';
import ISonenUpdateButton from '../EventInfo/ISonenUpdateButton.vue';

const { Event } = useEventCommonStoreRef();

const selectedEvent = ref<Eventinfo | null>(null);

const { AddLoader, LoadState } = useTaskLoader();

/**
 * The vmodel value containing the selected event to copy contestants from
 */
const value = defineModel<Eventinfo | null>({ required: true });

/**
 * Contains a list of all the files that have been loaded
 * This can be multiple in case it is an event running over multiple days
 */
const externalEventData = ref<ExternalEventDatasourceResponse[]>([]);

/**
 * The actual selected external event data. If it is more than one it defaults to the first one
 */
const selectedExternalEventData = defineModel<ExternalEventDatasourceResponse | null>('externalData', { required: false });

/**
 * Whenever a event is selected
 * @param item
 */
const onItemSelected = async (item: TypeAheadItem) => {
    AddLoader(async () => {
        selectedEvent.value = await EventDao.Event(item.ID);
        value.value = selectedEvent.value;
        externalEventData.value = [];
        selectedExternalEventData.value = null;
    }, '');
};

watch(selectedExternalEventData, (nv) => {
    if (nv) {
        selectedEvent.value = null;
        value.value = null;
    }
});

onMounted(async () => {});
</script>
